<div class="alert-container">
    <div class="alert-icon">
        <mat-icon color="warn" class="alert-icon__cancel">cancel</mat-icon>
    </div>
    <div class="alert-description">
        <div class="alert-description__title">Atenție</div>
        <div class="alert-description__text">Adresa de email sau CNP|CUI folosit nu a fost identificata. Va rugam sa verificati informatiile.</div>
    </div>
    <div class="alert-action">
        <button (click)="closeDialog()" mat-raised-button color="primary" class="alert-action__close-btn">Inchide</button>
    </div>
</div>